import { Badge } from "@mantine/core";
import { IconPointFilled } from "@tabler/icons-react";

export const ColorDotBadge = ({ color, bg, children, ...props }) => (
    <Badge
        leftSection={<IconPointFilled style={{ color }} />}
        radius="md"
        styles={{
            root: { backgroundColor: bg, color },
        }}
        {...props}
    >
        {children}
    </Badge>
);
